import { useQuery } from "@tanstack/react-query";
import { XLg } from "react-bootstrap-icons";
import { useDocumentApi } from "@/hooks/useApi";
import Loading from "../Loading";
import style from "./PdfViewer.module.scss";

interface Props {
  documentId?: string;
  height: number;
  width: number;
  url?: string;
  onClose?: () => void;
}

export default function PdfViewer({ documentId, url, height, onClose }: Props) {
  const documentApi = useDocumentApi();
  const documentUrlQuery = useQuery({
    queryKey: ["documentApi.documentGetPdfUrl", documentId],
    queryFn: async () => {
      return await documentApi.documentGetPdfUrl({
        documentId: documentId ?? "",
      });
    },
    enabled: !!documentId && !url,
    select: (documentUrl) => {
      return JSON.parse(documentUrl);
    },
    retry: 1,
  });

  return (
    <Loading isLoading={!!url && documentUrlQuery.isLoading}>
      <div>
        <div style={{ height: height, width: "100%" }}>
          {onClose && (
            <div className={style.closeButtonContainer}>
              <button
                aria-label="Close PDF viewer"
                onClick={onClose}
                type="button"
                title="Close PDF viewer"
              >
                <XLg size={14} />
              </button>
            </div>
          )}
          <iframe
            data-testid="pdf-viewer-iframe"
            title="pdf"
            src={url || documentUrlQuery.data}
            width="100%"
            height="100%"
          >
            This browser does not support PDFs. Please download the PDF to view
            it: <a href={url || documentUrlQuery.data}>Download PDF</a>
          </iframe>
        </div>
      </div>
    </Loading>
  );
}
